import React from 'react';
import { PRODUCT_TYPES } from '../../../constants';
import { formatPrice } from '../../../utils';

const OrderDetailsList = ({
  orders,
  permissions,
  handleEditOrder,
  handleCopyOrder,
  handleDeleteConfirm,
  isLoading
}) => {
  if (orders.length === 0) {
    return (
      <div className="no-orders">
        <p>Henüz sipariş eklenmemiş.</p>
      </div>
    );
  }

  return (
    <div className="orders-list">
      {/* Desktop Tablo Görünümü */}
      <table className="orders-table">
        <thead>
          <tr>
            <th>Ürün Tipi</th>
            <th>Oda</th>
            <th>Ürün Adı</th>
            <th>Ölçüler (cm)</th>
            <th>Pile Modeli</th>
            <th>Kullanılan Mt/Mt²</th>
            <th>Birim Fiyat</th>
            <th>Adet</th>
            <th>Toplam</th>
            <th>İndirimli</th>
            <th>Not</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td className="product-type-cell">
                <span>{PRODUCT_TYPES[order.productType]?.label || order.productType}</span>
              </td>
              <td>{order.roomName}</td>
              <td>
                {order.productType === 'plise' ? (
                  <>
                    {order.pliseProduct1Name}
                    {order.pliseProduct2Name && ` + ${order.pliseProduct2Name}`}
                  </>
                ) : order.productType === 'rustik' ? (
                  <>
                    <div className="product-name-text">{order.productName}{order.productVariant ? ` - ${order.productVariant}` : ''}</div>
                    <div className="product-sub-info" style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
                      {order.ayakModel && <span>{order.ayakModel}</span>}
                      {order.ayakCap && <span> | Çap: {order.ayakCap}</span>}
                      {order.ayakUzunluk && <span> | Uz: {order.ayakUzunluk}</span>}
                      {order.ayakRenkKodu && <span> | Renk: {order.ayakRenkKodu}</span>}
                    </div>
                    {(order.rustikAksesuarlar?.length > 0 || order.rustikRaySecenekleri?.length > 0) && (
                      <div className="product-sub-info" style={{ fontSize: '10px', color: '#b04309', marginTop: '1px' }}>
                        <span>{(order.rustikAksesuarlar?.length || 0) + (order.rustikRaySecenekleri?.length || 0)} Ek Seçenek</span>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="product-name-text">
                      {order.productName}{order.productVariant ? ` - ${order.productVariant}` : ''}
                      {order.direction ? ` (Yön: ${order.direction})` : ''}
                      {order.altEtekKatlama && <span style={{ fontSize: '11px', color: 'var(--primary-600)', marginLeft: '6px' }}>(Alt Etek Katlamalı)</span>}
                    </div>
                    {order.productType === 'kanat' && (order.hasOzelTasarim || order.ozelProductName) && (
                      <div className="product-sub-info" style={{ fontSize: '11px', color: '#0284c7', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #0284c7' }}>
                        <strong>Özel Tasarım:</strong> {order.ozelProductName}
                        {order.ozelProductVariant ? ` (${order.ozelProductVariant})` : ''}
                        {order.ozelWidth && ` | ${order.ozelWidth}`}
                        {order.ozelHeight && `x${order.ozelHeight} cm`}
                        {order.ozelPileModel && ` | ${order.ozelPileModel}`}
                        {order.ozelQuantity && ` | ${order.ozelQuantity} Adet`}
                      </div>
                    )}
                    {order.productType === 'kanat' && (order.hasAstar || order.astarProductName) && (
                      <div className="product-sub-info" style={{ fontSize: '11px', color: '#0f766e', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #0f766e' }}>
                        <strong>Astar:</strong> {order.astarProductName}
                        {order.astarProductVariant ? ` (${order.astarProductVariant})` : ''}
                        {order.astarPrice ? ` | ${formatPrice(order.astarPrice)} ₺` : ''}
                      </div>
                    )}
                    {order.accessories && order.accessories.length > 0 && (
                      <div className="product-sub-info" style={{ fontSize: '11px', color: '#475569', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #64748b' }}>
                        <strong>Aksesuarlar:</strong> {order.accessories.map(acc => {
                          const isMetre = acc.unit === 'metre';
                          return `${acc.name} (${isMetre ? `${acc.metre}m x ` : ''}${acc.quantity} ad)`;
                        }).join(', ')}
                      </div>
                    )}
                  </>
                )}
              </td>
              <td>
                {order.width && `${order.width}`}
                {order.width && order.height && ' x '}
                {order.height && `${order.height}`}
              </td>
              <td>{order.pileModel || '-'}</td>
              <td>
                {order.productType === 'raySistemi'
                  ? (order.usedMeter ? `${order.usedMeter} m` : '-')
                  : order.productType === 'rustik'
                    ? (order.usedCm ? `${order.usedCm} cm` : '-')
                    : (order.usedM2 || '-')}
              </td>
              <td>
                {order.productType === 'plise' ? (
                  <>
                    {formatPrice(order.pliseProduct1Price)}
                    {order.pliseProduct2Price && parseFloat(order.pliseProduct2Price) > 0 && ` + ${formatPrice(order.pliseProduct2Price)}`}
                    {' ₺'}
                  </>
                ) : order.productType === 'katlamaliPerde' ? (
                  `${formatPrice(order.fabricPrice)} / ${formatPrice(order.mechanismPrice)} ₺`
                ) : order.unitPrice && parseFloat(order.unitPrice) > 0 ? (
                  `${formatPrice(order.unitPrice)} ₺`
                ) : (
                  '-'
                )}
              </td>
              <td>
                {order.productType === 'plise' 
                  ? (order.pliseItems?.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0) || 0)
                  : (order.quantity || '1')}
              </td>
              <td>{formatPrice(order.totalPrice)} ₺</td>
              <td>
                {order.discountedPrice && parseFloat(order.discount) > 0 ? (
                  <span className="discounted-price-display">
                    {formatPrice(order.discountedPrice)} ₺
                  </span>
                ) : (
                  '-'
                )}
              </td>
              <td>{order.notes}</td>
              <td>
                <div className="action-buttons">
                  {permissions?.canEditOrder && (
                    <button onClick={() => handleEditOrder(order)} className="edit-btn" disabled={isLoading} title="Düzenle">
                      <i className="fas fa-edit"></i>
                    </button>
                  )}
                  {permissions?.canCreateOrder && (
                    <button onClick={() => handleCopyOrder(order)} className="copy-btn" disabled={isLoading} title="Kopyala">
                      <i className="fas fa-copy"></i>
                    </button>
                  )}
                  {permissions?.canDeleteOrder && (
                    <button onClick={() => handleDeleteConfirm(order)} className="delete-btn" disabled={isLoading} title="Sil">
                      <i className="fas fa-trash"></i>
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobil ve Tablet Kart Görünümü */}
      <div className="orders-cards">
        {orders.map((order) => (
          <div key={order.id} className="order-card">
            <div className="order-card-header">
              <div className="order-card-title">
                {PRODUCT_TYPES[order.productType]?.label || order.productType}
              </div>
              <div className="order-card-actions">
                {permissions?.canEditOrder && (
                  <button onClick={() => handleEditOrder(order)} className="edit-btn" disabled={isLoading} title="Düzenle">
                    <i className="fas fa-edit"></i>
                  </button>
                )}
                {permissions?.canCreateOrder && (
                  <button onClick={() => handleCopyOrder(order)} className="copy-btn" disabled={isLoading} title="Kopyala">
                    <i className="fas fa-copy"></i>
                  </button>
                )}
                {permissions?.canDeleteOrder && (
                  <button onClick={() => handleDeleteConfirm(order)} className="delete-btn" disabled={isLoading} title="Sil">
                    <i className="fas fa-trash"></i>
                  </button>
                )}
              </div>
            </div>
            <div className="order-card-content">
              <div className="order-card-item">
                <div className="order-card-label">Oda</div>
                <div className="order-card-value">{order.roomName}</div>
              </div>
              <div className="order-card-item">
                <div className="order-card-label">Ürün Adı</div>
                <div className="order-card-value">
                  {order.productType === 'plise' ? (
                    <>
                      {order.pliseProduct1Name}
                      {order.pliseProduct2Name && ` + ${order.pliseProduct2Name}`}
                    </>
                  ) : (
                    <>
                      <div className="product-name-text">
                        {order.productName}{order.productVariant ? ` - ${order.productVariant}` : ''}
                        {order.direction ? ` (Yön: ${order.direction})` : ''}
                        {order.altEtekKatlama && <span style={{ fontSize: '11px', color: 'var(--primary-600)', marginLeft: '6px' }}>(Alt Etek Katlamalı)</span>}
                      </div>
                      {order.productType === 'kanat' && (order.hasOzelTasarim || order.ozelProductName) && (
                        <div style={{ fontSize: '11px', color: '#0284c7', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #0284c7' }}>
                          <strong>Özel Tasarım:</strong> {order.ozelProductName}
                          {order.ozelProductVariant ? ` (${order.ozelProductVariant})` : ''}
                          {order.ozelWidth && ` | ${order.ozelWidth}`}
                          {order.ozelHeight && `x${order.ozelHeight} cm`}
                          {order.ozelPileModel && ` | ${order.ozelPileModel}`}
                          {order.ozelQuantity && ` | ${order.ozelQuantity} Adet`}
                        </div>
                      )}
                      {order.productType === 'kanat' && (order.hasAstar || order.astarProductName) && (
                        <div style={{ fontSize: '11px', color: '#0f766e', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #0f766e' }}>
                          <strong>Astar:</strong> {order.astarProductName}
                          {order.astarProductVariant ? ` (${order.astarProductVariant})` : ''}
                          {order.astarPrice ? ` | ${formatPrice(order.astarPrice)} ₺` : ''}
                        </div>
                      )}
                      {order.accessories && order.accessories.length > 0 && (
                        <div style={{ fontSize: '11px', color: '#475569', marginTop: '4px', paddingLeft: '6px', borderLeft: '2px solid #64748b' }}>
                          <strong>Aksesuarlar:</strong> {order.accessories.map(acc => {
                            const isMetre = acc.unit === 'metre';
                            return `${acc.name} (${isMetre ? `${acc.metre}m x ` : ''}${acc.quantity} ad)`;
                          }).join(', ')}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="order-card-item">
                <div className="order-card-label">Ölçüler (cm)</div>
                <div className="order-card-value">
                  {order.width && `${order.width}`}
                  {order.width && order.height && ' x '}
                  {order.height && `${order.height}`}
                </div>
              </div>
              <div className="order-card-item">
                <div className="order-card-label">Toplam</div>
                <div className="order-card-value">{formatPrice(order.totalPrice)} ₺</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderDetailsList;
